import { IField } from 'utils/interfaces/IField';
import InputTypes from 'utils/enums/inputTypes';

const order: IField[] = [
    {
        presentation: 'Status',
        label: 'Status',
        name: 'status',
        type: InputTypes.text,
        columns: 3
    }
];

export default order;
